"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";
import { FaFacebook, FaHeart, FaInstagram, FaLinkedin, FaPinterest, FaYoutube } from "react-icons/fa";
import FooterAiLinks from "./FooterAiLinks";
import BrandReveal from "../ui/BrandReveal";
import { FaXTwitter } from "react-icons/fa6";
import { useState } from "react";
import { hoverCircleClassName } from "../become-partner/AboutHero";

// Renders nothing until opened (form + Turnstile + validation stack) — every
// page ships the footer, so keep this out of every route's initial bundle.
const BrochureDownloadPopup = dynamic(() => import("@/components/common/BrochureDownloadPopup"), {
  ssr: false
});
export const footerColumns = [{
  title: "Solutions",
  links: [{
    label: "Home Service App",
    href: "/home-services-app"
  }, {
    label: "Grocery App Solution",
    href: "/readymade-grocery-mobile-application-solution"
  }, {
    label: "Salon & Spa Software",
    href: "/salon-spa-software"
  }, {
    label: "Restaurant Management",
    href: "/restaurant-management"
  }, {
    label: "Multi Vendor Marketplace",
    href: "/multi-vendor-marketplace"
  }, {
    label: "Doctor Appointment Booking CRM",
    href: "/appointment-booking-crm"
  }, {
    label: "Brokerage Order Booking App",
    href: "/brokerage-order"
  }, {
    label: "Ai Location Marketplace",
    href: "/ai-location-marcket-place"
  }, {
    label: "Custom CRM Development",
    href: "/custom-crm-development"
  }]
}, {
  title: "Services",
  links: [{
    label: "UI/UX Design",
    href: "/design"
  }, {
    label: "Website Development",
    href: "/web-development"
  }, {
    label: "Mobile App Development",
    href: "/app-development"
  }, {
    label: "eCommerce Development",
    href: "/web-development#ecommerce"
  }, {
    label: "Search Engine Optimization",
    href: "/marketing"
  }, {
    label: "Shopify Development",
    href: "/shopify-development"
  }, {
    label: "Laravel Development",
    href: "/laravel-development"
  }, {
    label: "Flutter Development",
    href: "/flutter-development"
  }, {
    label: "AI Development",
    href: "/ai"
  }]
}, {
  title: "Hire Developers",
  links: [
  // { label: "Hire PHP Developer", href: "/hire-php-developer" },
  {
    label: "Hire UI/UX Designer",
    href: "/hire-ui-ux-designer"
  }, {
    label: "Hire AI Developers",
    href: "/hire-ai-developer"
  }, {
    label: "Hire Shopify Developers",
    href: "/hire-shopify-developer"
  }, {
    label: "Hire Laravel Developers",
    href: "/hire-laravel-developer"
  }, {
    label: "Hire Flutter Developers",
    href: "/hire-flutter-developer"
  }]
}];
export const technologies: {
  label: string;
  href?: string;
}[] = [
// { label: "OpenAI" },
// { label: "Langchain" },
{
  label: "Flutter",
  href: "/technology/flutter"
}, {
  label: "PHP Laravel",
  href: "/technology/laravel"
}, {
  label: "Wordpress",
  href: "/technology/wordpress"
}, {
  label: "Shopify",
  href: "/technology/shopify"
}, {
  label: "React Native",
  href: "/technology/react-native"
}, {
  label: "React Js",
  href: "/technology/react-js"
}, {
  label: "Next Js",
  href: "/technology/next-js"
}, {
  label: "Webflow",
  href: "/technology/webflow"
}
// { label: "Anthropic" },

// { label: "Figma" },

// { label: "Opencart" },
];
export const socialLinks = [{
  name: "Facebook",
  icon: FaFacebook,
  href: "https://www.facebook.com/thedezine.in"
}, {
  name: "LinkedIn",
  icon: FaLinkedin,
  href: "https://www.linkedin.com/company/thedezine"
}, {
  name: "Twitter",
  icon: FaXTwitter,
  href: "https://twitter.com/thedezine"
}, {
  name: "Instagram",
  icon: FaInstagram,
  href: "https://www.instagram.com/thedezine.in/"
}, {
  name: "YouTube",
  icon: FaYoutube,
  href: "https://www.youtube.com/channel/UCcUtanP_HrSFDJZH0ZcfViw"
}, {
  name: "Pinterest",
  icon: FaPinterest,
  href: "https://in.pinterest.com/thedezine/"
}];
const currentYear = new Date().getFullYear();
const groups = [footerColumns[0], null, footerColumns[1], footerColumns[2]];
const linkClass = "inline-block pb-1 font-open-sans text-sm leading-6 transition-colors hover:text-pink-500 sm:text-base sm:leading-7 xl:text-base dark:hover:text-pink-400";
export default function Footer() {
  const $ = _c(26);
  const pathname = usePathname();
  const [isBrochurePopupOpen, setIsBrochurePopupOpen] = useState(false);
  let t0;
  if ($[0] !== pathname) {
    t0 = href => href === "/" ? pathname === "/" : pathname === href || pathname.startsWith(`${href}/`);
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isCurrent = t0;
  let t1;
  if ($[2] !== isCurrent) {
    t1 = groups.map((column, index) => <div key={column?.title ?? "Technologies"} className="min-w-0 lg:px-5"><h3 className="mb-4 font-poppins text-xl font-medium leading-7 text-primary sm:mb-5 sm:text-2xl dark:text-white">{column?.title ?? "Technologies"}</h3>{index === 1 ? <div className="grid grid-cols-2 gap-x-6">{[technologies.slice(0, Math.ceil(technologies.length / 2)), technologies.slice(Math.ceil(technologies.length / 2))].map(items => <ul key={items[0]?.href ?? items[0]?.label} className="space-y-0">{items.map(link => <li key={link.href ?? link.label}>{link.href ? <Link href={link.href} aria-current={isCurrent(link.href) ? "page" : undefined} className={`${linkClass} ${isCurrent(link.href) ? "font-semibold text-pink-500 dark:text-pink-400" : "text-gray-700 dark:text-gray-300"}`}>{link.label}</Link> : <p className={`${linkClass} text-gray-700 dark:text-gray-300`}>{link.label}</p>}</li>)}</ul>)}</div> : <ul className="space-y-0">{column?.links.map(link_0 => <li key={link_0.label}><Link href={link_0.href} aria-current={isCurrent(link_0.href) ? "page" : undefined} className={`${linkClass} ${link_0.href === "/appointment-booking-crm" ? "whitespace-nowrap lg:max-xl:text-sm" : ""} ${isCurrent(link_0.href) ? "font-semibold text-pink-500 dark:text-pink-400" : "text-gray-700 dark:text-gray-300"}`}>{link_0.label}</Link></li>)}</ul>}</div>);
    $[2] = isCurrent;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <div><div data-footer-section={true} className="grid grid-cols-1 gap-x-10 gap-y-8 py-10 sm:grid-cols-2 sm:gap-y-10 lg:-mx-4 lg:grid-cols-4 lg:gap-x-0 lg:py-12">{t1}</div></div>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Link href="/" aria-label="The Dezine home" className="mx-auto lg:mx-0"><Image src="/images/logo/logo.png" alt="The Dezine" width={190} height={55} className="h-auto w-40 object-contain sm:w-48 dark:hidden" /><Image src="/images/header/darkmodelogo.png" alt="The Dezine" width={190} height={55} className="hidden h-auto w-40 object-contain sm:w-48 dark:block" /></Link>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex min-w-0 flex-col items-center gap-9 sm:gap-10 lg:items-start">{t3}<div className="flex flex-wrap items-center justify-center gap-2 lg:justify-start">{socialLinks.map(_temp)}</div></div>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <p className="text-center font-open-sans text-sm leading-6 text-gray-700 sm:text-base sm:leading-7 lg:text-left dark:text-gray-300">{"The Dezine is an IT company offering a web & mobile application development services for diverse industries. Our solutions have the capability to challenge the limits and give business a competitive edge."}</p>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setIsBrochurePopupOpen(true);
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div data-footer-section={true} data-footer-brochure-section={true} className="border-y border-gray-200 py-7 dark:border-gray-800"><div className="grid items-start gap-6 lg:grid-cols-3 lg:gap-8">{t4}<div className="lg:col-span-2">{t5}<div className="mt-5 flex flex-col items-center justify-between gap-5 xl:flex-row"><button type="button" onClick={t6} className="group relative inline-flex h-11 w-full cursor-pointer items-center justify-center overflow-hidden rounded-lg bg-gradient-to-r from-violet-700 to-sky-400 px-5 text-base font-semibold text-white shadow-lg transition-transform hover:-translate-y-0.5 sm:w-auto"><span className="relative z-10">Download Brochure</span><span className={hoverCircleClassName} aria-hidden={true} /></button><FooterAiLinks /></div></div></div></div>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="flex items-center justify-center gap-2 lg:justify-start"><span className="h-8 w-[246px] shrink-0 bg-[url('/images/images/home-footer-sprt-new-v1.png')] bg-[-100px_-70px] bg-no-repeat" /></div>;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span>Copyright © {currentYear} The Dezine. All rights reserved.</span>;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <p className="flex flex-wrap items-center justify-center gap-x-1 text-center font-open-sans text-[11px] leading-5 min-[420px]:flex-nowrap min-[420px]:whitespace-nowrap sm:text-sm sm:leading-6 dark:text-gray-300">{t9}<span className="inline-flex items-center gap-1">Crafted with<FaHeart role="img" aria-label="love" className="text-xs text-red-500" /></span></p>;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== isCurrent) {
    t11 = <div>{t7}<div data-footer-section={true} className="py-5"><div className="grid items-center gap-4 text-sm leading-6 text-gray-700 sm:gap-5 lg:grid-cols-3 dark:text-gray-300">{t8}{t10}<nav aria-label="Footer legal links" className="flex flex-wrap items-center justify-center gap-y-2 text-xs sm:text-sm lg:justify-end">{[{
              label: "Terms",
              href: "/terms"
            }, {
              label: "Policy",
              href: "/privacy"
            }, {
              label: "Sitemap",
              href: "/sitemap"
            }, {
              label: "FAQs",
              href: "/faq"
            }].map((item, index_0, links) => <span key={item.label} className="inline-flex items-center"><Link href={item.href} aria-current={isCurrent(item.href) ? "page" : undefined} className={`font-open-sans transition-colors hover:text-pink-500 dark:hover:text-pink-400 ${isCurrent(item.href) ? "font-semibold text-pink-500 dark:text-pink-400" : ""}`}>{item.label}</Link>{index_0 < links.length - 1 && <span aria-hidden={true} className="mx-2 sm:mx-3">|</span>}</span>)}</nav></div></div></div>;
    $[14] = isCurrent;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <BrandReveal />;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t11 || $[18] !== t2) {
    t13 = <div className="mx-auto w-full max-w-300 px-4 sm:px-6 lg:px-8">{t2}{t11}{t12}</div>;
    $[17] = t11;
    $[18] = t2;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => setIsBrochurePopupOpen(false);
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== isBrochurePopupOpen) {
    t15 = <BrochureDownloadPopup isOpen={isBrochurePopupOpen} onClose={t14} onSuccess={_temp2} />;
    $[21] = isBrochurePopupOpen;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t13 || $[24] !== t15) {
    t16 = <footer className="overflow-hidden bg-white font-sans text-gray-900 dark:border-indigo-500 dark:bg-gray-950 dark:text-gray-200">{t13}{t15}</footer>;
    $[23] = t13;
    $[24] = t15;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  return t16;
}
function _temp2() {
  window.sessionStorage.setItem("dezine-brochure-entry", "complete");
  window.location.assign("/brochure");
}
function _temp(social) {
  const Icon = social.icon;
  return <a key={social.name} href={social.href} target="_blank" rel="noreferrer" aria-label={social.name} className="flex h-8 w-8 items-center justify-center text-gray-700 transition-colors hover:text-pink-500 dark:text-gray-200"><Icon className="size-6" /></a>;
}